<template>
    <ScrollPanel class="horizontal-scrollpanel-table horizontal-scrollpanel-table-delegates absolute" >
        <div class="scroll-content" :class="{'justify-content-center': justifyContentCenter, 'justify-content-start': !justifyContentCenter}">
            <div v-for="(delegate, index) in sortedDelegatesList"  :key="index">
                <Avatar v-if="user && user.id===delegate.id" class="avatar is-user" :class="{ 'is-active-user': ((activeUser) && (delegate.id === activeUser.id)), 'is-selected-user': (selectedUser!==null ? selectedUser.id : '')===delegate.id}" size="small" shape="circle" v-tooltip.top="{ value: getTooltipValueForUser(delegate, activeUser) }" @click="$emit('clicked-avatar', delegate)">
                    <SvgUserMe className="avatar-me-svg" :color="((activeUser) && (delegate.id === activeUser.id)) ? 'var(--avatar-inuse-font-color)' : 'var(--theme-font-color)'"/>
                </Avatar>
                <Avatar v-else class="avatar" :class="{ 'is-active-user': ((activeUser) && (delegate.id === activeUser.id)), 'is-selected-user': (selectedUser!==null ? selectedUser.id : '')===delegate.id}" :label="getAvatarLabelFromFirstNameAndLastName(delegate.first_name, delegate.last_name)" size="small" shape="circle" v-tooltip.top="{ value: getTooltipValueForUser(delegate, activeUser) }" @click="$emit('clicked-avatar', delegate)"/>
            </div>
            <div v-if="!justifyContentCenter" style="width: 18px;"/>
        </div>
    </ScrollPanel>
</template>

<script setup>
// --- IMPORTS ---
import { toRefs, computed } from "vue";
// PrimeVue
import ScrollPanel from "primevue/scrollpanel";
import Avatar from "primevue/avatar";
// vue
import SvgUserMe from '@/components/SVGs/SvgUserMe.vue'
// Others
import AvatarsUtils from '@/composables/AvatarsUtils'
import { useStore } from 'vuex';

const store = useStore()
const { getAvatarLabelFromFirstNameAndLastName, getTooltipValueForUser } = AvatarsUtils()

// --- PROPS ---
const props = defineProps({
    delegates: Array,
    activeUser: {
        type: Object,
        default: null
    },
    selectedUser: {
        type: Object,
        default: null
    },
    justifyContentCenter: {
        type: Boolean,
        default: false
    }
})
const { delegates, activeUser } = toRefs(props)

// --- User info ---
const user = computed(() => store.state.user.user)

// --- EMITS ---
const emit = defineEmits(['clicked-avatar'])

// --- Stored list (active user first) ---
const sortedDelegatesList = computed(() => {
    // First sort in the alphabetical order. Also, if I belong to the delegates, I go first.
    const temp = delegates.value.sort((a,b) => { // SORT IN THE ALPHABETICAL ORDER
            if (a.id === user.value.id) { return -1 }
            if (b.id === user.value.id) { return 1 }
            const nameA = getAvatarLabelFromFirstNameAndLastName(a.first_name, a.last_name)
            const nameB = getAvatarLabelFromFirstNameAndLastName(b.first_name, b.last_name)
            if (nameA < nameB) { return -1 }
            else if (nameA > nameB) { return 1 }
            else { return 0 }
        })
    // If there is an active user, it goes first. Even before me
    return temp.some((delegate) => activeUser.value && delegate.id === activeUser.value.id) ? [activeUser.value, ...temp.filter((delegate) => activeUser.value && delegate.id !== activeUser.value.id)] : temp;
}) 
</script>

<style scoped>
.scroll-content {
  display: grid;
  grid-auto-flow: column;
}
</style>